/**************************************
** AtlasApplication
*
* Encapsulates the once global methods
***************************************/
define('atlas/AtlasApplication',
  ['atlas/AtlasClientCapabilities', 'atlas/AtlasImageLoader', 'atlas/AtlasViewer', 'atlas/AtlasConstants'],
  function (AtlasClientCapabilities, AtlasImageLoader, AtlasViewer, Constants) {

  'use strict';

  var Application = {
  };

  Application._loadBatch = function (batch, object) {
    if (!batch) {
      return;
    }

    var _loader=object;

    for (var i=0; i<batch.images.length; ++i) {
      /* jshint loopfunc: true */

      //skip anything that was already priority loaded
      if (batch.images[i].complete) {
        continue;
      }
      var image=new Image();

      //add an error event listener to catch 404s
      if (AtlasClientCapabilities.getCapabilities().eventListener) {
        //not a great situation, but need to continue loading
        image.addEventListener('error', function() {
          //need to determine what to do here
          this.complete=true;
        }, true);
      }
      else if (AtlasClientCapabilities.getCapabilities().jqueryEvents) {
        jQuery(image).bind('error', function() {
          this.complete=true;
        });
      }

      try {
        image.src=batch.images[i].src;
        image.batch=batch.index;
        image.index=batch.images[i].index;
        image.resolution=batch.images[i].resolution;
        image.startTime=new Date();


        _loader._loadingQueue.push(image);
      }
      catch(exception) {
        image=null;
      }
    }
  };

  Application._loadOverride = function (object) {
    var loader=object;
    //add an image to the the loading queue in the appropriate place
    var image=new Image();

    image.src=loader._override.src;
    image.batch=loader._override.batch;
    image.index=loader._override.index;
    image.resolution=loader._override.resolution;
    image.startTime=new Date();

    loader._loadingQueue.push(image);
    //reset the override
    loader._override=null;
  };

  Application._continueLoading = function (object) {
    if (!object || object._cancelLoading) {
      return;
    }

    var _loader=object;

    //because this gets called outside the context of the object (in the timer), it uses the reference
    Application._updateLoadingQueues(_loader);

    if (_loader._override) {
      Application._loadOverride(_loader);
    }

    //only calculate progress if necessary
    if (_loader._progressSubscribers.length>0) {
      //current batch progress will be current batch image length - loading queue length
      //total image progress will be sum of total images - load queue length + remaining batch sizes
      var progress={
        batch: (_loader._currentBatch-1),
        batchName: _loader._queue._batches[_loader._currentBatch-1].name,
        batchImages: _loader._queue._batches[_loader._currentBatch-1].images.length,
        batchLoaded: (_loader._queue._batches[_loader._currentBatch-1].images.length-_loader._loadingQueue.length),
        batchProgress: 0,
        images: 0,
        imagesLoaded: 0,
        imagesProgress: 0
      };

      for (var i=0; i<_loader._queue._batches.length; ++i) {
        progress.images+=_loader._queue._batches[i].images.length;
        if (i < (_loader._currentBatch-1)) {
          progress.imagesLoaded+=_loader._queue._batches[i].images.length;
        }
        if (i === (_loader._currentBatch-1)) {
          progress.imagesLoaded+=(_loader._queue._batches[i].images.length-_loader._loadingQueue.length);
        }
      }
      progress.batchProgress=(progress.batchLoaded/progress.batchImages);
      progress.imagesProgress=(progress.imagesLoaded/progress.images);

      for (var s=0; s<_loader._progressSubscribers.length; ++s) {
        _loader._progressSubscribers[s].callback(progress, _loader._progressSubscribers[s].data);
      }
    }


    //make sure other batch has loaded
    if (_loader._loadingQueue.length === 0) {
      if (_loader._currentBatch<_loader._queue._batches.length) {
        //completed a batch, notify subscribers
        var batch=_loader._queue._batches[_loader._currentBatch];

        for (var bs=0; bs<_loader._batchSubscribers.length; ++bs) {
          _loader._batchSubscribers[bs].callback(batch.name, batch.index, _loader._batchSubscribers[bs].data);
        }

        //go to the next batch
        batch=_loader._queue._batches[_loader._currentBatch++];
        Application._loadBatch(batch, _loader);
        _loader._timer=setTimeout(function() {
          Application._continueLoading(_loader);
        }, 100);
      }
      else {
        //completed the last batch, notify subscribers
        var batch=_loader._queue._batches[_loader._currentBatch-1];

        for (var bs=0; bs<_loader._batchSubscribers.length; ++bs) {
          _loader._batchSubscribers[bs].callback(batch.name, batch.index, _loader._batchSubscribers[bs].data);
        }

        //notify the completed subscribers
        for (var cs=0; cs<_loader._completedSubscribers.length; ++cs) {
          _loader._completedSubscribers[cs].callback(_loader._completedSubscribers[cs].data);
        }
      }
    }
    else {
      _loader._timer=setTimeout(function() {
        Application._continueLoading(_loader);
      }, 100);
    }
  };

  Application._updateLoadingQueues = function (object) {
    if (!object) {
      return;
    }

    var _loader=object;

    //update the queue with the images that have loaded
    var remove=[];
    for (var i=0; i < _loader._loadingQueue.length; ++i) {
      if ((_loader._loadingQueue[i].complete)&&((_loader._loadingQueue[i].width+_loader._loadingQueue[i].height)>0)) {
        var batch=_loader._queue._batches[_loader._loadingQueue[i].batch];

        //probably occured due to configuration change
        if (!batch) {
          return;
        }

        remove.push(i);
        for (var l=0; l<batch.images.length; ++l) {
          //check to make sure same index and resolution
          if ((batch.images[l].index === _loader._loadingQueue[i].index) && (batch.images[l].resolution === _loader._loadingQueue[i].resolution)) {
            batch.images[l].complete=true;
            batch.images[l].startTime=_loader._loadingQueue[i].startTime;
            batch.images[l].endTime=new Date();
            batch.images[l].elapsedTime=batch.images[l].endTime-batch.images[l].startTime;
            batch.images[l].htmlImage=_loader._loadingQueue[i];
            _loader._imageCache.store(batch.images[l]);
            //notify the subscribers if not previously loaded (we are not using the image cache for this b/c
            //the image cache only stores the highest resolution version of the image - that may need to change
            //but for now we want to track if previously loaded for this resolution - these could be combined
            //when re-written to handle retina)
            if (!_loader.previouslyLoaded(batch.images[l].resolution, batch.images[l].index)) {
              _loader.addToLoadedList(batch.images[l].resolution, batch.images[l].index);
              for (var is=0; is<_loader._imageSubscribers.length; ++is) {
                _loader._imageSubscribers[is].callback(batch.images[l], _loader._imageSubscribers[is].data);
              }
            }
          }
        }
      }
    }
    //remove the completed items from the loading queue
    if (remove.length>0) {
      for (var i=(remove.length-1); i>=0; --i) {
        _loader._loadingQueue.splice(remove[i], 1);
      }
    }
    //update the batches
    for (var b=0; b < _loader._queue._batches.length; ++b) {
      //only update batches that are not yet complete
      if (_loader._queue._batches[b].complete) {
        continue;
      }

      var skip=false;
      for (var i=0; ((i < _loader._queue._batches[b].images.length)&&(!skip)); ++i) {
        if (!_loader._queue._batches[b].images[i].complete) {
          skip=true;
        }
      }
      //if we get here and skip is still false, then this batch is complete
      if (!skip) {
        _loader._queue._batches[b].complete=true;
        //call the custom callback if there is one
        if (_loader._queue._batches[b].onComplete) {
          _loader._queue._batches[b].onComplete(_loader._queue._batches[b].onCompleteParameters);
        }
      }
    }

  };

  Application._onChange = function (e, d) {
    var horizontal, vertical;

    if (typeof d !== 'undefined') {
      horizontal = e.horizontal || d.horizontal;
      vertical = e.vertical || d.vertical;
    }
    else {
      horizontal = e.horizontal;
      vertical = e.vertical;
    }

    if ((horizontal !== 0)||(vertical !== 0)) {
      var atlas=AtlasViewer.getInstance();
      atlas.rotate(horizontal, vertical);
    }

    var capabilities=AtlasClientCapabilities.getCapabilities();
    if (capabilities.forceRefreshDuration === Constants.FORCE_CANVAS_REFRESH_UNTIL_MOVED) {
      AtlasViewer.getInstance().setForceCanvasRefresh(false);
    }

    if (e.preventDefault) {
      e.preventDefault();
    }
    else {
      e.returnValue = false;
    }

    if (e.stopPropagation) {
      e.stopPropagation();
    }

    return false;
  };

  Application._tick = function () {
    var currentTime = new Date();

    if (AtlasViewer.getInstance()._stopRendering) {
      return;
    }

    if ((currentTime - AtlasViewer.getInstance()._lastRenderTime) > 30000) {
      AtlasViewer.getInstance().forceResizeRefresh();
      AtlasViewer.getInstance()._lastRenderTime = currentTime;
    }



    //perform any rotational animation that is needed
    Application._animate();
    //render out the current image
    Application._render();
    //schedule the next tick
    setTimeout(Application._tick, 50);
  };

  Application._animate = function () {
    var atlas=AtlasViewer.getInstance();
    var rotation=atlas._autoRotationInfo;

    if (rotation._rotating) {
      if ((rotation._currentLatitudeIndex === rotation._latitudeEndIndex)&&(rotation._currentLongitudeIndex === rotation._longitudeEndIndex)) {
        rotation._rotating=false;
      }
      else {
        var currentTime=new Date();
        var elapsedTime=currentTime-rotation._startTime;

        //number of frames traveled along the long edge
        var longEdgeFrames=(Constants.ANIMATION_FRAMES_PER_SECOND/1000)*elapsedTime;

        //detect if things go wrong, and cancel rotation on next iteration
        if (longEdgeFrames>=Math.max(atlas._sphere._latitudes, atlas._sphere._longitudes)) {
          rotation._rotating=false;
        }

        //number of frames traveled along the short edge
        var shortEdgeFrames=rotation._shortEdgeRatio*longEdgeFrames;

        //make both of these whole numbers by rounding
        longEdgeFrames=Math.floor(longEdgeFrames);
        shortEdgeFrames=Math.floor(shortEdgeFrames);

        //assume longitude is long edge
        var longitudeFrames=longEdgeFrames;
        var latitudeFrames=shortEdgeFrames;

        if (rotation._longEdge === "latitude") {
          //long edge is longitude, short edge is latitude
          longitudeFrames=shortEdgeFrames;
          latitudeFrames=longEdgeFrames;
        }

        //handle latitudes
        if (rotation._currentLatitudeIndex !== rotation._latitudeEndIndex) {
          if (rotation._currentLatitudeIndex < rotation._latitudeEndIndex) {
            for (var i = 0; i <= latitudeFrames; ++i) {
              rotation._currentLatitudeIndex=rotation._latitudeStartIndex+i;
              if (rotation._currentLatitudeIndex === rotation._latitudeEndIndex) {
                break;
              }
            }
          }
          else if (rotation._currentLatitudeIndex>rotation._latitudeEndIndex) {
            for (var i = 0; i <= latitudeFrames; ++i) {
              rotation._currentLatitudeIndex=rotation._latitudeStartIndex-i;
              if (rotation._currentLatitudeIndex === rotation._latitudeEndIndex) {
                break;
              }
            }
          }
        }
        if ((rotation._currentLatitudeIndex<0)||(rotation._currentLatitudeIndex>=atlas._sphere._latitudes)) {
          rotation._currentLatitudeIndex=rotation._latitudeEndIndex;
        }

        //handle longitudes
        if (rotation._currentLongitudeIndex !== rotation._longitudeEndIndex) {
          if (rotation._travelRight) {
            for (var i = 0; i <= longitudeFrames; ++i) {
              rotation._currentLongitudeIndex=rotation._longitudeStartIndex+i;
              if (rotation._currentLongitudeIndex>=atlas._sphere._longitudes) {
                rotation._currentLongitudeIndex-=atlas._sphere._longitudes;
              }
              if (rotation._currentLongitudeIndex === rotation._longitudeEndIndex) {
                break;
              }
            }
          }
          else {
            for (var i = 0; i <= longitudeFrames; ++i) {
              rotation._currentLongitudeIndex=rotation._longitudeStartIndex-i;
              if (rotation._currentLongitudeIndex<0) {
                rotation._currentLongitudeIndex+=atlas._sphere._longitudes;
              }
              if (rotation._currentLongitudeIndex === rotation._longitudeEndIndex) {
                break;
              }
            }
          }
        }

        //update the camera position to the centriod of the face
        var imageIndex=Constants.latitudeMarkers[rotation._currentLatitudeIndex]+Constants.longitudeMarkers[rotation._currentLongitudeIndex];
        atlas.setNextImageIndex(imageIndex);
      }
    }

    //update everything
    if (((atlas._frame++) % atlas._framesPerUpdate) === 0) {
      atlas._frame=0;
    }
  };

  Application._render = function () {
    var atlas=AtlasViewer.getInstance();
    //can't render to nothing
    if (!atlas._viewerElement) {
      return;
    }

    if ((atlas._canvasIsDirty)||((atlas._context)&&(atlas._forceCanvasRefresh))) {
      var cache=atlas._imageCache;

      if (atlas._nextImageIndex) {
        atlas._currentImageIndex=atlas._nextImageIndex;
      }

      var cell=atlas._sphere.getSphereCellForIndex(atlas._currentImageIndex);
      if (cell) {
        var image=cache.fetch(cell.imageIndex);
        //can't render nothing
        if (!image || !image.htmlImage || !image.htmlImage.complete) { //render after image load complete, (low bandwidth issue GRN-325)
          return;
        }

        //atlas._context will only be non-null if we renderToCanvas is true and we successfully got a context from the element
        if (atlas._context) {
          try {
            atlas._context.imageSmoothingEnabled = false;
            atlas._context.drawImage(image.htmlImage, 0, 0, atlas._viewerElement.width, atlas._viewerElement.height);
          }
          catch(e) {
            //FF errors
            return;
          }
        }
        else {
          atlas._viewerElement.innerHTML='<img style="max-width:100%; max-height:100%" src=' + image.htmlImage.src + '>';
        }

        //check to see if we have callback for this one
        if ((atlas._onOneTimeRenderImageIndex)&&(atlas._onOneTimeRenderImageIndex[atlas._currentImageIndex])) {
          atlas._onOneTimeRenderImageIndex[atlas._currentImageIndex].callback(atlas._onOneTimeRenderImageIndex[atlas._currentImageIndex].object,
            atlas._currentImageIndex);
          atlas._onOneTimeRenderImageIndex[atlas._currentImageIndex]=null;
        }

        if (atlas._firstRender) {
          //callback that the canvas is ready
          if (atlas._onCanvasReady) {
            atlas._onCanvasReady();
          }
          atlas._firstRender=false;
        }
      }
      atlas._canvasIsDirty=false;
    }
  };

  return Application;
});

